import { addSideEffects, initAction } from '@poa/state';
import moment from 'moment';
import { normalizeDateForBackend } from '../../utils/dates';
import { clone } from '../shared/clone';
import { changeStatus, fetch, setDates } from './calendar.actions';

addSideEffects(fetch, async (_, { actions, env, store }) => {

  console.log('fetching calendar');
  try {
    // fetch statuses
    const statuses = await env.api.calendar.fetchStatuses();
    actions.calendarActions.resetStatuses(statuses);

    // fetch sorting
    const grouping = await env.api.calendar.fetchGrouping();
    actions.calendarActions.resetGrouping(grouping);

    const { startDate, endDate } = store.calendar.filters;
    const response = await env.api.calendar.fetchCalendar(
      normalizeDateForBackend(startDate),
      normalizeDateForBackend(endDate),
      store.calendar.filters.status.selected
    );
    actions.calendarActions.fetchSuccess(response);
  } catch (e) {
    console.error(e);
    actions.calendarActions.fetchFailed();
    throw e;
  }
});

addSideEffects(setDates, async ({ shouldFetch }, { actions, env, store }) => {
  try {
    if (!shouldFetch) {
      return;
    }

    const { startDate, endDate } = store.calendar.filters;
    await env.storage.setItem('calendar-dates', clone({ startDate, endDate }));

    console.log('setDates fetchCalendar');
    const response = await env.api.calendar.fetchCalendar(
      normalizeDateForBackend(startDate),
      normalizeDateForBackend(endDate),
      store.calendar.filters.status.selected
    );

    actions.calendarActions.fetchSuccess(response);
  } catch (e) {
    console.error(e);
    actions.calendarActions.fetchFailed();
    throw e;
  }
});

addSideEffects(changeStatus, async ({ status }, { actions, env, store }) => {
  try {
    const { startDate, endDate } = store.calendar.filters;
    const response = await env.api.calendar.fetchCalendar(
      normalizeDateForBackend(startDate),
      normalizeDateForBackend(endDate),
      status
    );

    actions.calendarActions.fetchSuccess(response);
  } catch (e) {
    console.error(e);
    actions.calendarActions.fetchFailed();
    throw e;
  }
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const dates = await env.storage.getItem('calendar-dates');

  if (dates) {
    actions.calendarActions.setDates(
      dates.startDate ? moment(dates.startDate) : null,
      dates.endDate ? moment(dates.endDate) : null,
      false
    );
    return;
  }
});
